import { Component, OnInit } from '@angular/core';
import { MainService } from '../../services/main.service';

declare const $;

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss']
})
export class MainPageComponent implements OnInit {

  source: string;

  constructor(private mainService: MainService) { }

  ngOnInit() {
    $('.home').height(window.innerHeight);
    this.source = this.mainService.getSource();
  }

}
